import * as React from 'react';
import { SwxlFooterSection } from './swxl-footer-section';
import { ExtendedContextStore, FooterSection } from 'types/flex-definitions';
import { UitkCard, UitkCardContent } from 'uitk-react-cards';
import { formatText } from 'bernie-l10n';

interface SwxlFooterProps {
  context: ExtendedContextStore;
  className?: string;
}

export const SwxlFooter: React.FC<SwxlFooterProps> = ({ context, className }: SwxlFooterProps) => {
  const { viewModelResponse, footer } = context;
  const links =
    (viewModelResponse &&
      viewModelResponse.composition &&
      viewModelResponse.composition.page &&
      viewModelResponse.composition.page.regionList.length >= 1 &&
      viewModelResponse.composition.page.regionList[0].name === 'rooms' &&
      viewModelResponse.composition.page.regionList[0].modules.some(module => module.name === 'link-juice') &&
      viewModelResponse.composition.page.regionList[0].modules.find(module => module.name === 'link-juice').model &&
      viewModelResponse.composition.page.regionList[0].modules.find(module => module.name === 'link-juice').model.categories) ||
    [];
  const linksFooterV2 = (footer && footer.tripPlanningSections) || [];
  const finalFooter = [...links, ...linksFooterV2];

  return (
    finalFooter.length > 0 && (
      <div data-stid="swxl-footer" className={className}>
        <SwxlFooterSections title={formatText('hotels.infosite.sxwl.footer.tripPlanning')} sections={finalFooter} />
      </div>
    )
  );
};

interface SwxlFooterSectionsProps {
  title: string;
  sections: FooterSection[];
}

const SwxlFooterSections: React.FC<SwxlFooterSectionsProps> = ({ title, sections }: SwxlFooterSectionsProps) => (
  <UitkCard className="all-b-padding-three">
    <UitkCardContent>
      <h3 className="uitk-type-heading-600 all-t-padding-three all-l-padding-three">{title}</h3>
    </UitkCardContent>
    {sections.filter(item => item).map((item, index) => (
      <UitkCardContent key={item.name ? item.name : item.title}>
        <SwxlFooterSection headerTitle={title} title={item.name ? item.name : item.title} links={item.links} indexKey={index} />
      </UitkCardContent>
    ))}
  </UitkCard>
);
